<template>
  <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <strong>{{ $t("keyLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("titleLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("statusLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("jiraUserLabel") }} <br />{{ $t("bouUserLabel") }} </strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("beneficiariesFilterCardType") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("searchByCompanyName") }}</strong>
          </td>          
          <td  valign="middle">
            <strong>{{ $t("beneficiariesTableNameAndSurname") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("cnpCardIDLabel") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("lastFourPAN") }}</strong>
          </td>
          <td  valign="middle">
            <strong>{{ $t("descriptionLabel") }}</strong>
          </td>
          <td cvalign="middle">
            <!-- <strong>{{ $t("valueLabel") }}</strong> -->
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.complaints === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(complaint, index) in complaints">
          <tr
            :key="index"
            class="trhover parent"
            :class="index % 2 === 0 && 'gri-cell'"
            :style="getColorForComplaint(complaint)"
          >
            <td valign="middle" style="min-width: 70px;">
              <a
                class="detailsOrderMobile priority-show-6 display-inline-block"
                @click="getComplaintDetails(complaint)"
              >
                <font-awesome-icon
                  icon="minus-circle"
                  v-if="
                    detailsMobile && complaint === complaintSelectedMobile
                  "
                />
                <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
              </a>
              <b><a :href="'https://upromania.atlassian.net/browse/' + complaint.key" target="_blank" > {{ complaint.key }} </a></b>
              <br />
                <span>{{ complaint.created_at }}</span>
                <!-- <span>{{ displayDate(complaint.created) }}</span> -->
            </td>
            <td valign="middle">
              {{ complaint.title }}
            </td>
            <td valign="middle">
              {{ complaint.status }}
            </td>
            <td valign="middle">
              {{ complaint.jira_user }}
              <br />
              {{ complaint.state && complaint.state.blocked_by ? "(" + complaint.state.blocked_by + ")" : "" }}
            </td>
            <td valign="priority-1">
              {{ complaint.user_data ? complaint.user_data.card.type : "" }}
            </td>
            <td valign="middle" class="priority-1">
                {{ complaint.user_data ? complaint.user_data.employer.name : "" }}
            </td>
            <td valign="middle" class="priority-1">
               {{ complaint.user_data ? complaint.user_data.first_name + " " + complaint.user_data.last_name : "" }}
            </td>
            <td valign="middle" class="priority-1 culoare-12">
                {{ complaint.cnp ? complaint.cnp : "N/A" }} /
                <br/>
                {{ complaint.card_id ? complaint.card_id : "N/A" }}

            </td>            
            <td valign="middle" class="priority-1">
                {{ complaint.user_data ? complaint.user_data.card.card_last_digits : "" }}
            </td>
            
            <td valign="middle" class="priority-4 overflow max-width-230" v-b-tooltip.hover
                :title="[[complaint.description]]">

              {{ complaint.description ? complaint.description.substring(0, 70) : "" }}
            </td>
            <td valign="middle">
                  <a
                    class="see-more cursor-pointer"
                    @click="getComplaintDetails(complaint)"
                  >
                    <font-awesome-icon
                      icon="arrow-alt-circle-right"
                      size="2x"
                    />
                  </a>
                  <br/>
                  <a
                    class="see-more cursor-pointer"
                    @click="assignToComplaint(complaint)"
                    v-if = "complaint.state && !complaint.state.user_id"
                  >
                    <font-awesome-icon
                      icon="user-plus"
                      size="lg"
                    />
                  </a>
                  <a
                    class="see-more cursor-pointer"
                    @click="unAssignToComplaint(complaint)"
                    v-if = "complaint.state && complaint.state.user_id && complaint.state.user_id === user.id"
                  >
                    <font-awesome-icon
                      icon="user-minus"
                      size="lg"
                    />
                  </a>
                  
                </td>
                <td valign="middle">
                  
                  <div v-if = "complaint.state && complaint.state.user_id && complaint.state.user_id === user.id">

                    <a
                    class="see-more cursor-pointer"
                    >
                    <input
                  type="color"
                  class="color-picker"
                  v-model="complaint.state.color"
                  @input="selectColor($event.target.value, complaint)" />
                </a>
                <br />
                <a
                class="see-more cursor-pointer"
                @click="addNote(complaint)"
                v-if = "complaint.state && complaint.state.user_id && complaint.state.user_id === user.id"
                >
                <font-awesome-icon
                icon="edit"
                size="2x"
                />
              </a>
            </div>
                </td>
          </tr>
          <tr
            :key="index + complaints.length"
            class="child"
            :class="index % 2 === 0 && 'gri-cell'"
            v-show="detailsMobile && complaint === complaintSelectedMobile"
          >
            <td colspan="12">
              <p class="priority-show-1">
                <strong>{{ $t("keyLabel") }} : &nbsp;&nbsp;</strong>
                <span>              
                  <a :href="'https://upromania.atlassian.net/browse/' + complaint.key" target="_blank" > {{ complaint.key }} </a>
              </span>
              </p>
              <p class="priority-show-1">
                <strong>{{ $t("titleLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.title }}</span>
                <br />
                <!-- <span>{{ displayDate(complaint.created) }}</span> -->
                <span>{{ complaint.created_at }}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("statusLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.status }} </span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("jiraUserLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.jira_user }} </span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("beneficiariesFilterCardType") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ? complaint.user_data.card.type : "" }} </span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("searchByCompanyName") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ? complaint.user_data.employer.name : "" }}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("beneficiariesTableNameAndSurname") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ? complaint.user_data.first_name + " " + complaint.user_data.last_name : "" }}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("beneficiariesTableCNP") }} : &nbsp;&nbsp;</strong>
                <span class="culoare-12"> 
                  {{ complaint.cnp ? complaint.cnp : "N/A" }} /
                <br/>
                {{ complaint.card_id ? complaint.card_id : "N/A" }}</span>
              </p>
              <p class="priority-show-6">
                <strong>{{ $t("lastFourPAN") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.user_data ? complaint.user_data.card.card_last_digits : "" }}</span>
              </p>
              <p class="priority-show-6 overflow max-width-230">
                <strong>{{ $t("descriptionLabel") }} : &nbsp;&nbsp;</strong>
                <span>{{ complaint.description ? complaint.description.substring(0, 70) : "" }}</span>
              </p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <ComplaintInfoPopup  :complaint-details="complaintDetails" />
    <div id="modal_popup_add_note" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_add_note', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div>
          {{ $t("addNoteLabel") }}
            <form
               @submit.prevent="addComplaintNote"
            >
            <textarea
                v-model="newNote"
                required
              />  
              <input
                type="submit"
                :value="[[$t('saveChangesLabel')]]"
              />
              
            </form>
            
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
  import moment from "moment";
  import Cookies from "js-cookie";
  import httpServiceBenef from "@/http/http-ben-support.js";
  import { VBTooltipPlugin } from "bootstrap-vue";
  import ComplaintInfoPopup from "./ComplaintInfoPopup.vue";
  // import ComplaintInfoPopup from "@/components/company/beneficiaries-support/ComplaintInfoPopup.vue";


  export default {
    name: "CardTransactionTable",
    props: {
      complaints: Array,
      msg: String,
      user: Object
    },
    directive: {
      "v-b-tooltip": VBTooltipPlugin
    },
    components: {
      ComplaintInfoPopup,
    },
    data() {
      return {
        detailsMobile: false,
        complaintSelectedMobile: null,
        transactionError: null,
        complaintDetails: {},
        newNote: "",
        selectedComplaint: null
      };
    },
    methods: {
      displayDate(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format(
          "DD/MM/YYYY"
        );
      },
      displayDateTime(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format(
          "DD/MM/YYYY HH:mm"
        );
      },
      selectTransactionMobile(index) {
        this.complaintSelectedMobile = this.complaints[index];
        this.detailsMobile = !this.detailsMobile;
      },
      showModalPopup(elementId, show) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      selectColor(color, selectedComplaint){
        selectedComplaint.state.color = color;
        this.assignError = null,
          this.showModalPopup("modal_popup_loading", true);
        httpServiceBenef.beneficiariesService
          .modifyComplaintState(
            selectedComplaint.id,
            {
              user_id: this.user.id,
              color: color,
            },
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              selectedComplaint.state = response.data;
              this.showModalPopup("modal_popup_loading", false);
            } else if (response.status == 400 || response.status == 403) {
              this.assignError = {};
            }
          });
      },
      getComplaintDetails(selectedComplaint) {
        this.showModalPopup("modal_popup_loading", true);
        httpServiceBenef.beneficiariesService
        .getComplaintDetails(
            selectedComplaint.id,
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              this.complaintDetails = response.data;
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_details", true);
            } else if (response.status == 400 || response.status == 403) {
              this.complaintDetails = null;
            }
          });
      },
      assignToComplaint(selectedComplaint) {
        this.assignError = null,
          this.showModalPopup("modal_popup_loading", true);
        httpServiceBenef.beneficiariesService
          .addComplaintState(
            selectedComplaint.id,
            { user_id: this.user.id },
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              selectedComplaint.state = response.data;
              this.showModalPopup("modal_popup_loading", false);
            } else if (response.status == 400 || response.status == 403) {
              this.assignError = {};
            }
          });
      },
      unAssignToComplaint(selectedComplaint) {
        this.assignError = null,
          this.showModalPopup("modal_popup_loading", true);
        httpServiceBenef.beneficiariesService
          .unAssignToComplaint(
            selectedComplaint.id,
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              selectedComplaint.state = {};
              this.showModalPopup("modal_popup_loading", false);
            } else if (response.status == 400 || response.status == 403) {
              this.assignError = {};
            }
          });
      },
      addNote(complaint){
        this.selectedComplaint = complaint;
        this.showModalPopup("modal_popup_add_note", true);
      },
      addComplaintNote() {
        this.showModalPopup("modal_popup_loading", true);
        httpServiceBenef.beneficiariesService
          .addComplaintNotes(
            this.selectedComplaint.id,
            {id: this.selectedComplaint.id,
              description: this.newNote,
            },
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
                    this.showModalPopup("modal_popup_add_note", false);

          })
          .then((response) => {
            if (response.status == 200) {
            } else if (response.status == 400 || response.status == 403) {
              this.noteError = {code: 500}
            }
            this.showModalPopup("modal_popup_loading", false);
          });
      },
      getColorForComplaint(complaint){
        if (complaint.state && complaint.state.color){
          return "background-color: " + complaint.state.color ;
        }
        return "";
      }
    },
    mounted() {
      localStorage.removeItem("selected_beneficiary");
    }
  };
</script>
<style scoped>
  #modal_popup_details .modal-popup-content {
    text-align: left !important;
    max-width: 60% !important;
    width: 60%;
  }

  .color-picker {
  margin-right: 10px;
  width: 15px;
  height: 15px;
  border: 3px solid white;
  margin: 2px;
  background: transparent;
}

  .invoices-table {
    padding: 1px;
  }

  .overflow {
    overflow-wrap: break-word;
  }

  .max-width-230 {
    max-width: 230px;
  }

  .hover-table tr.trhover:hover a,
  .hover-table tr.trhover:hover a:hover {
    color: #fff;
  }

</style>
<style scoped src="@/assets/styles/beneficiary.css"></style>
